export default __webpack_public_path__ + "static/media/qr.dbdb55ba.png";